import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AanAfwezigheid } from 'src/app/afas-classes/aanafwezigheid.class';
import { Realisation } from 'src/app/classes/realisation';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-week-schedule-realisations',
    templateUrl: './week-schedule-realisations.component.html',
    standalone: false,
})
export class WeekScheduleRealisationsComponent implements OnChanges {
    @Input() beginDate: Date;
    @Input() maxDate: Date;
    @Input() sourceRealisations: Realisation[];
    @Input() aanAfwezigheid: AanAfwezigheid[];

    realisations: Realisation[];

    constructor(private router: Router) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.beginDate || changes.sourceRealisations || changes.aanAfwezigheid) {
            this.loadData();
        }
    }

    openRealisation(realisation: Realisation) {
        if (!realisation.dayOff && realisation.begindate < this.maxDate) {
            this.router.navigateByUrl(
                `/weekschedule/${Utils.formatDate(realisation.bookdate ?? realisation.begindate)}`
            );
        }
    }

    private loadData() {
        this.realisations = this.sourceRealisations
            .filter(realisation => Utils.getTimeOrNull(realisation.begindate) < this.maxDate.getTime())
            .map(realisation => ({ ...realisation, begindate: new Date(realisation.begindate) }));

        for (let i = 0; i <= 6; i++) {
            const loopDay = Utils.setTime(new Date(this.beginDate), 0, 0);
            loopDay.setDate(loopDay.getDate() + i);
            const realisation = this.realisations.find(
                item => Utils.dateString(item.bookdate) === Utils.dateString(loopDay)
            );
            if (realisation === undefined) {
                this.realisations.push({
                    planning_id: 0,
                    user_id: 1,
                    dayOff: true,
                    bookdate: loopDay,
                    begindate: loopDay,
                    enddate: Utils.setTimeNewDate(loopDay, 23, 59, 59),
                });
            }
        }
        this.realisations.sort((a, b) => Utils.realisationSort(a) - Utils.realisationSort(b));

        this.aanAfwezigheid.forEach(aanAfwezig => {
            const realisation = this.realisations.find(
                item => Utils.dateString(item.bookdate) === Utils.dateString(aanAfwezig.startDate)
            );
            if (realisation?.dayOff) {
                realisation.dayOffReason = Utils.minutes(aanAfwezig.hours) + ' - ' + aanAfwezig.omschrijving;
            }
        });
    }
}
